export default {
    Home: 'home',
    Fax: 'print',
    Cell: 'mobile',
    Work: 'building',
    Other: 'fas fa-phone'
}
